import { CustomQuestionAnswer } from "../../models/nps/custom-question-answer.model";

export class ListCustomQuestionAnswerRequest {
    public listCustomQuestionAnswer: CustomQuestionAnswer[] = [];
}